import { Provider } from '@angular/core';

import { IrsUseCasesImpl } from '@app/domain/use-cases/ptrab/irs/irs.use-cases';
import { IRS_USE_CASES } from '@app/domain/use-cases/ptrab/irs/irs.use-cases.contract';

export const irsUseCasesProvider: Provider = {
  provide: IRS_USE_CASES,
  useClass: IrsUseCasesImpl
};
